import React, { cloneElement } from 'react';

import { LinkProps } from './logic';

export const withProviderProps =
  (Component: React.ComponentType<LinkProps>): React.FC<LinkProps> =>
  ({ provider = <a />, ...rest }: LinkProps) => {
    const currentProvider =
      provider || rest?.href ? <a href={rest?.href} /> : <div />;
    if (!Component) return null;

    return cloneElement<LinkProps>(currentProvider, {
      ...{
        ...provider?.props,
        target: rest.newTab ? '_blank' : undefined,
        tabIndex: -1,
        style: { ...(provider?.props?.style || {}), display: 'inline-flex' }
      },
      children: <Component {...rest} />
    });
  };
